module.exports = __webpack_public_path__ + "static/media/high-fid-4.2eaa0376.svg";